import React, { useState, useEffect } from "react";
import cmsUtils from "../../utils/cmsUtils";
import { Item } from '../item';
import utils from "../../../utils";
import './style.scss';

export function TwoTabsPanel(props) {
    const item = props.item;
    const subItems = item.items || [];
    const cmsOption = props.cmsOption || {};

    const subItemsElts = subItems.map((subItem, index) =>
        <Item item={subItem} key={subItem.itemId} cmsOption={cmsOption}></Item>
    );

    const cssClass = utils.classNames(
        "cms_item",
        "twoTabsPanel",
        "contentPanel--",
        item.cssClass || item.anchorName || ""
    );

    const firstAccordionTopic = subItemsElts.length > 0 ? subItemsElts[0]?.props.item.payloads[0]?.value : null;
    const [selectedAnchor, setSelectedAnchor] = useState(firstAccordionTopic);
    const [isAnimating, setIsAnimating] = useState(false);

    const handleClick = (accordionTopic) => {
        if (accordionTopic === selectedAnchor) return;
        setIsAnimating(true);
        setSelectedAnchor(accordionTopic);
    };

    useEffect(() => {
        if (isAnimating) {
            const timer = setTimeout(() => setIsAnimating(false), 500);
            return () => clearTimeout(timer);
        }
    }, [isAnimating]);

    return (
        <section
            className={cssClass}
            data-cms-item-id={cmsOption.isCmsEdit && item.itemId}
            id={item.anchorName}
        >
            <div className="twoTabsPanel__bg"></div>
            <div>
                <div className="two-tabs-panel">
                    <ul>
                        {subItemsElts.map((subItem, index) => (
                            // subItem.props.item.anchorName ? (
                            <React.Fragment key={index}>
                                <li
                                    key={index}
                                    onClick={() => handleClick(subItem.props.item.payloads[0].value)}
                                    className={`two-tabs-item ${selectedAnchor === subItem.props.item.payloads[0].value ? "selected" : ""}`}
                                >
                                    {subItem.props.item.payloads[0].value === "NEW" ? (
                                        <h2>{subItem.props.item.payloads[0].value}<span className="span-img"><img src="/assets/icons/red-heart-2.png"></img></span></h2>
                                    ) : (
                                        <h2>{subItem.props.item.payloads[0].value}</h2>
                                    )}
                                </li>
                                {index < subItemsElts.length - 1 && (
                                    <span><h2 style={{ marginBottom: '0', fontWeight: '700' }}>/</h2></span>
                                )}
                            </React.Fragment>
                            // ) : null
                        ))}
                    </ul>
                </div>
                <div className={`tab-content ${isAnimating ? "fade-out" : "fade-in"}`}>
                    {subItemsElts.filter(subItem => subItem.props.item.payloads[0].value === selectedAnchor)}
                </div>
            </div>
        </section>
    );
}